
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("8BzoM"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("8BzoM", function(module, exports) {

let $643d3cda2d58cd2d$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $643d3cda2d58cd2d$var$load("h3ABO"),
    $643d3cda2d58cd2d$var$load("fSobj"),
    $643d3cda2d58cd2d$var$load("74u2y"),
    $643d3cda2d58cd2d$var$load("2YffH"),
    $643d3cda2d58cd2d$var$load("1aTst"),
    $643d3cda2d58cd2d$var$load("6mHrv"),
    $643d3cda2d58cd2d$var$load("awWN9"),
    $643d3cda2d58cd2d$var$load("9CYct"),
    $643d3cda2d58cd2d$var$load("iIoyG"),
    $643d3cda2d58cd2d$var$load("2xn4F"),
    $643d3cda2d58cd2d$var$load("hZtKG"),
    $643d3cda2d58cd2d$var$load("iNmaF"),
    $643d3cda2d58cd2d$var$load("lVO3w"),
    $643d3cda2d58cd2d$var$load("hyzoX"),
    $643d3cda2d58cd2d$var$load("h9Ed7"),
    $643d3cda2d58cd2d$var$load("eBRUf"),
    $643d3cda2d58cd2d$var$load("tKhaz"),
    $643d3cda2d58cd2d$var$load("bogQM"),
    $643d3cda2d58cd2d$var$load("jq3Ai"),
    $643d3cda2d58cd2d$var$load("bv7z8"),
    $643d3cda2d58cd2d$var$load("aNhGE"),
    $643d3cda2d58cd2d$var$load("8A3nE"),
    $643d3cda2d58cd2d$var$load("8YSo7"),
    $643d3cda2d58cd2d$var$load("g7ggm"),
    $643d3cda2d58cd2d$var$load("Wowvf"),
    $643d3cda2d58cd2d$var$load("gusn7"),
    $643d3cda2d58cd2d$var$load("kiGNy"),
    $643d3cda2d58cd2d$var$load("7do1E"),
    $643d3cda2d58cd2d$var$load("77dkW"),
    $643d3cda2d58cd2d$var$load("gBNir"),
    $643d3cda2d58cd2d$var$load("g9CVe"),
    $643d3cda2d58cd2d$var$load("7oiUM"),
    $643d3cda2d58cd2d$var$load("8t3po"),
    $643d3cda2d58cd2d$var$load("855o0"),
    $643d3cda2d58cd2d$var$load("8MfZE"),
    $643d3cda2d58cd2d$var$load("hv4mn"),
    $643d3cda2d58cd2d$var$load("dek7I"),
    $643d3cda2d58cd2d$var$load("3SmkN"),
    $643d3cda2d58cd2d$var$load("dYtBN"),
    $643d3cda2d58cd2d$var$load("kNV5Y"),
    $643d3cda2d58cd2d$var$load("6wr18"),
    $643d3cda2d58cd2d$var$load("kjZZD"),
    $643d3cda2d58cd2d$var$load("bkc7o"),
    $643d3cda2d58cd2d$var$load("2wlUS"),
    $643d3cda2d58cd2d$var$load("9u7sS"),
    $643d3cda2d58cd2d$var$load("1fem1"),
    $643d3cda2d58cd2d$var$load("ffEVr"),
    $643d3cda2d58cd2d$var$load("dRpV3"),
    $643d3cda2d58cd2d$var$load("dTsOE"),
    $643d3cda2d58cd2d$var$load("hhss7"),
    $643d3cda2d58cd2d$var$load("9fvYm"),
    $643d3cda2d58cd2d$var$load("im1Yv"),
    $643d3cda2d58cd2d$var$load("henq4"),
    $643d3cda2d58cd2d$var$load("8fMw3"),
    $643d3cda2d58cd2d$var$load("hogcU"),
    $643d3cda2d58cd2d$var$load("dAdaw"),
    $643d3cda2d58cd2d$var$load("1FeuN"),
    $643d3cda2d58cd2d$var$load("lrSMb"),
    $643d3cda2d58cd2d$var$load("7EorR"),
    $643d3cda2d58cd2d$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.cf109a13.js.map
